<template>
	<sf-content-layout>
		<template v-slot:location>
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<sf-content-title :title="getMessage_('SWCC000585')" useFavorite :favorite="screen.favoriteYn === 'Y'" :onFavorite="onFavorite" />
		</template>
		<template v-slot:titleEnd>
			<sf-button v-if="isButton_(scrId, 'AD')" :onClick="registerStation">{{ getMessage_('SWCC000245') }}</sf-button>

			<!-- <sf-button :onClick="registerStation">{{ getMessage_('SWCC000245') }}</sf-button> -->
		</template>
		<template v-slot:content>
			<center-content :scrId="scrId" />
		</template>
	</sf-content-layout>
</template>

<script>
import CenterContent from './Content/Content';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/RegisterReportingPoint/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	components: { CenterContent },
	computed: {
		...rootComputed,
		...serviceComputed,
		locations() {
			let result = [];
			if (this.screen && this.screen.menuLocation) {
				result = this.screen.menuLocation.map(str => this.getMessage_(str));
			}

			return result;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		registerStation() {
			let defaultFlags = {};

			this.flags.forEach(flag => {
				//체크박스 값들에 기본 값 부여
				defaultFlags[flag.value.toLowerCase()] = 'N';
			});

			this.SET_STATE({
				key: 'popupParams',
				value: {
					type: 'create',
					show: true,
					selectedRow: { regId: this.user.userId, chgId: this.user.userId, ...defaultFlags }
				}
			});
		},
		onFavorite() {
			this.$sf_toggleLoading(true);
			this.onFavorite_()
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	beforeDestroy() {
		this.resetState_();
	}
};
</script>

<style></style>
